const UnbeatableOfferMiddleIcon = props => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 24" fill="none" {...props}>
		<path
			d="M20.6515 0L7.76048 18.4583C6.07904 20.8881 3.31976 23.7869 0 24H22.3138C26.1078 24 28.9102 21.5702 30.7641 18.8419L44 0H20.6515Z"
			fill="currentColor"
		/>
	</svg>
);

export default UnbeatableOfferMiddleIcon;
